import * as React from 'react';
import { connect } from 'react-redux';
import { ADD_REPLACEMENT_VALUE, CREDIT_HISTORY, REGULAR_DRIVER, REGULAR_DRIVER_OTHER } from '../../../routes/routes';
import './PortablePossessions.css';
import { navigateTo } from '../../../actions/navigationActions';
import { setPortablePossessionsRisk } from '../../../actions/salesActions';
import { ProgressBar, Button, Dropdown, Image, Form } from 'react-bootstrap';
import { PRODUCT_BLING } from '../../../constants/constants';

class PortablePossesionsRisk extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            nextDisabled: true,
            selectedPortalPossessionsRisk: '',
            selectePortalPossessionsDropdown: false,
            loggedIn: this.props.auth.uid ? true : false,
        };

        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleCarRiskSelection = this.handleCarRiskSelection.bind(this);
        this.handleCarRiskDropdownToggle = this.handleCarRiskDropdownToggle.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    claimCountList = [
        { description: '0', id: 0 }, { description: '1', id: 1 }, { description: '2', id: 2 }, { description: '3', id: 3 }, { description: '4+', id: 4 }
    ]

    handleClick() {
        this.props.dispatchSetPortablePossessionsRisk(this.state.selectedPortalPossessionsRisk);
    }

    handleRedirect(nextPage: string) {
        this.props.redirectTo(nextPage);
    }

    async componentDidMount() {
    }

    async handleCarRiskSelection(e: any) {
        /* eslint eqeqeq: "off" */
        let selectedItem = this.claimCountList.filter(function (item) {
            return item.id == e
        })
        /* eslint eqeqeq: "warn" */
        await this.setState({ selectedPortalPossessionsRisk: selectedItem[0] });
        this.setState({ nextDisabled: selectedItem[0] === undefined });
    }

    async handleCarRiskDropdownToggle(e: any) {
        await this.setState({
            selectePortalPossessionsDropdown: !this.state.selectePortalPossessionsDropdown
        });
    }

    async handleBack(e: any) {
        if (this.props.sales.quoteType === PRODUCT_BLING) {
            this.props.redirectTo(ADD_REPLACEMENT_VALUE)
        }
    }

    public render() {
        let claimCounts = this.claimCountList.map((item) => {
            return <Dropdown.Item eventKey={item.id.toString()} key={item.id}>{item.description}</Dropdown.Item>
        });

        return (
            <div className={this.state.loggedIn ? "pt-lg-5 pb-5 logged-in" : "pt-lg-5 pb-5 logged-out"}>
                <div className="col-12 text-lg-center text-md-center">
                    <div className="container portal-possession-risk">
                        <div className="row justify-content-center mobile-mt-60px">
                            <div className="col-lg-12 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={35} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container mt-32px mobile-mt-20px">
                        <div className="row justify-content-center">
                            <div className="col-lg-12 col-md-12 nopa">
                                <div className="row noma">
                                    <div className="col nopa"></div>
                                    <div className="col-lg-10 nopa">
                                        <div className="ssp-addportable-possessions-crown-icon mt-0px text-center">
                                            <div className="ssp-sales-journey-crown-icon" title="Add portable possessions"></div>
                                        </div>
                                        <div className="ssp-portable-possession-risk-main-contentholder mt-21px mobile-mt-17px mb-28px mobile-mb-30px text-center ssp-addreplacement-value-p-holder">
                                            <div className="font-size-16px font-weight-normal ssp-addreplacement-value-intro-header">
                                                {this.props.sales.quoteType === PRODUCT_BLING && "Thanks, now tell us how many cellphone claims you (the policyholder) have had in the past 2 years (this includes loss or theft)"}
                                                {this.props.sales.quoteType != PRODUCT_BLING && "Please tell us how many portable possessions claims you (the policyholder) have had in the past 2 years (this includes loss or theft)"}
                                            </div>
                                        </div>
                                        <div className="row noma">
                                            <div className="col-lg-12 col-md-12 col-12 nopa">
                                                <Form.Label className={'left-align mb-6px nopa temp-text-box-label' + (this.state.selectedPortalPossessionsRisk !== "" ? "" : " no-opacity d-none")}>Select amount of claims </Form.Label>
                                                <Dropdown
                                                    id="carRisk-select-dropdown"
                                                    className="fit-full mb-0px pb-50px"
                                                    onSelect={this.handleCarRiskSelection}
                                                    onToggle={this.handleCarRiskDropdownToggle}>
                                                    <Dropdown.Toggle id="dropdown-basic">
                                                        <div className="row dropdown-height">
                                                            <div className="dropdown-basic-title-text col-11 mr-10px mobile-mr-0px">
                                                                {this.state.selectedPortalPossessionsRisk?.description}
                                                                {!this.state.selectedPortalPossessionsRisk &&
                                                                    <p>Select amount of claims</p>
                                                                }
                                                            </div>
                                                            <Image src='Images/red-arrow-up-24-px.svg' className={this.state.selectePortalPossessionsDropdown ? 'visible' : 'invisible'} alt="" />
                                                            <Image src='Images/red-arrow-down-24-px.svg' className={this.state.selectePortalPossessionsDropdown ? 'invisible' : 'visible'} alt="" />
                                                        </div>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu id='carRiskDropDown'>
                                                        {claimCounts}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>
                                        <div className="row noma justify-content-center mt-40px">
                                            <div className="col-12 col-lg-4 nopa">
                                                <Button className="btn btn-block btn-solid-red" id="NextButton" disabled={this.state.nextDisabled} onClick={this.handleClick}>Next</Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(navigateTo(des)),
        dispatchSetPortablePossessionsRisk: (portablePossessionsRisk: any) => dispatch(setPortablePossessionsRisk(portablePossessionsRisk))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PortablePossesionsRisk);